<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" v-slot:default="{ loading, error, retry }">
    <card-loading v-if="loading" />
    <card-reload v-else-if="error" @reload="retry()"/>
    <div v-else class="chart-card">

      <div class="flex flex-column">
        <div>
          <h1 class="f5 f4-l fw5 ma0 pa0 lh-title text-primary">
            {{ title }}
          </h1>
          <span class="db f6 f5-l ma0 pa0 lh-title text-secondary">
            {{ subtitle }}
          </span>
        </div>
      </div>

      <div class="flex flex-column mt4">
        <svg-plot :config="plotConfig">
          <svg-line :data="possibleEconomy.chart" />
          <svg-line :data="resultEconomy.chart" />
        </svg-plot>

        <ul class="list pa0 ma0 mt4">
          <li class="f6 flex items-center">
            <span class="square ma2" :style="'background-color: ' + possibleEconomy.legend.color + ';'"></span>{{ possibleEconomy.legend.label }}
          </li>
          <li class="f6 flex items-center">
            <span class="square ma2" :style="'background-color: ' + resultEconomy.legend.color + ';'"></span>{{ resultEconomy.legend.label }}
          </li>
        </ul>
      </div>
    </div>
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import CardLoading from '@/components/dashboard/CardLoading.vue'
import CardReload from '@/components/dashboard/CardReload.vue'
import SvgPlot from '@/components/charts/svg/plot/Plot.vue'
import SvgLine from '@/components/charts/svg/plot/Line.vue'
import { senseMap } from '@/plugins/colors.js'

export default {
  components: {
    ReportDataProvider,
    CardLoading,
    CardReload,
    SvgPlot,
    SvgLine
  },
  data () {
    return {
      requiredReports: ['economicEfficiency'],
      reports: null,
      title: 'Общий экономический эффект',
      subtitle: 'детализировано за период'
    }
  },
  computed: {
    report () {
      return this.reports.economicEfficiency
    },
    possibleEconomy () {
      const series = this.report.possibleEconomyByPeriod.map((val, i) => ({
        x: i, y: val
      }))
      return {
        chart: {
          series,
          style: {
            color: senseMap.planned
          }
        },
        legend: {
          label: 'Возможная экономия, ₽',
          color: senseMap.planned
        }
      }
    },
    resultEconomy () {
      const series = this.report.resultingEconomyByPeriod.map((val, i) => ({
        x: i, y: val
      }))
      return {
        chart: {
          series,
          style: {
            color: senseMap.defacto
          }
        },
        legend: {
          label: 'Полученная экономия, ₽',
          color: senseMap.defacto
        }
      }
    },
    plotConfig () {
      const labels = this.report.resultingEconomyByPeriod.map((_v, i) => ({ value: i, label: this.label(i) }))
      return {
        grid: {
          vertical: true,
          horizontal: false
        },
        axis: {
          x: labels,
          hidden: {
            y: true
          }
        },
        chartArea: {
          x: 5, y: 0, width: 90, height: 100
        }
      }
    }
  },
  methods: {
    label (offset) {
      const dates = this.$store.getters['dashboard/dates']
      const dateFormat = this.$store.getters['dashboard/format']
      // % hack для демо режима
      return dates[offset % dates.length].format(dateFormat)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-card {
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  background-color: #FFFFFF;
  border-radius: .25rem;
  min-width: 270px;
  max-width: 350px;
}
.legend-line {
  width: 100%;
  height: 0;
  border-top-left-radius: 20%;
  border-bottom-left-radius: 20%;
  border-top: 2px solid transparent;
  border-bottom: 2px solid transparent;
  border-left-style: solid;
  border-left-width: 270px;
  overflow: hidden;
}
@media screen and (min-width: 60em) {
  .legend-line {
    width: 100%;
    height: 0;
    border-top-left-radius: 20%;
    border-bottom-left-radius: 20%;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-left-style: solid;
    border-left-width: 270px;
    overflow: hidden;
  }
}
</style>
